import "@/style/informationDetail.scss"
import "@/style/inConstruction.scss"
import "@/utils/nav"
import "@/utils/tab"
import "@/utils/index"
import "@/utils/website.js"

let nav = $("#info-nav")

function get(par) {
    // 接收window.location.href中文参数用需要decodeURI解码
    const local_url = decodeURI(document.location.href)
    // 截取get字符串
    const getstr = local_url.substr(local_url.indexOf('?') + 1)
    // 解析成get数组
    const get = getstr.split('&')
    // 查找要找到参数
    for (var i in get) {
        if (get[i].indexOf(par + '=') >= 0) {
            return get[i].replace(par + '=', '');
        }
    }
    return false;
}

nav.append(get("nav") + '>')
const id = get("id");
const navId = get('navId')

if (id) {
    $.ajax({
        url: `/api/admin/official/exc/information/detail/${id}`,
        type: 'GET',
        // beforeSend: function (res) {
        //     res.setRequestHeader('tenantId', 1001)
        // },
        dataType: 'json',
        success: function (res) {
            $(".information-title").append(res.data.title)
            $("#time").append(res.data.publicTime)
            $(".policy-detail").append(res.data.details)
        }
    })
} else {
    $.get(`/api/admin/official/exc/informationPageList/${navId}`, function (res) {
        $(".information-title").append(res.data.records[0].title)
        $("#time").append(res.data.records[0].publicTime)
        $(".policy-detail").append(res.data.records[0].details)
    });
}

// 获取nav板块参数跳转相应页面
$(document).ready(function () {
    nav.click(function () {
        const text = nav.text()
        if (text === "热点>") {
            window.location.href = '/information.html?idx=2'
        } else if (text === "活动新闻>") {
            window.location.href = '/informationActivity.html?idx=2'
        } else {
            window.location.href = '/informationPolicy.html?idx=2'
        }
    });
});

